import CustomHead from 'components/commons/CustomHead'
import Template from 'components/LP/UIUXDesignLp2'

const UIUXDesignLp2: React.FC = () => {
  return (
    <>
      <CustomHead
        keyword={
          'UIデザイン UXデザイン 情報設計 スタイルガイド プロトタイピング OOUI ユーザーモデリング オブジェクトモデリング'
        }
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/services/uiuxdesign-lp2/'}
        title="UX/UIデザイン | サービス | Aitria（アイトリア）"
        description="UX/UIデザインでユーザー体験を向上させたいですか？Aitria（アイトリア）では、ユーザー中心設計のプロセスでユーザーの持つ課題を明確化し、正しい情報設計とユーザビリティ観点から実現可能なデザインをご提案します。スマホアプリやWebアプリを利用したビジネスを一緒に成功させましょう。"
      />
      <Template />
    </>
  )
}

export default UIUXDesignLp2
